import {SET_APP_STATE} from "./types";

export const setFetching = ()=>{
    return {
        type:SET_APP_STATE,
        payload:{
            state:FETCHING
        }
    }
}

export const setSubmitting = ()=>{
    return {
        type:SET_APP_STATE,
        payload:{
            state:SUBMITTING
        }
    }
}

export const setFailure = (message)=>{
    return {
        type:SET_APP_STATE,
        payload:{
            state:FAILURE,
            message:message
        }
    }
}

export const setSuccess = (message)=>{
    return {
        type:SET_APP_STATE,
        payload:{
            state:SUCCESS,
            message:message
        }
    }
}

export const setInitial = ()=>{
    return {
        type:SET_APP_STATE,
        payload:{
            state:INITIAL,
        }
    }
}

export const FETCHING = "FETCHING";
export const SUBMITTING = "SUBMITTING";
export const FAILURE = "FAILURE";
export const SUCCESS = "SUCCESS";
export const INITIAL = "INITIAL";